<template>
  <CCol sm="12" class="mt-2 mb-5">
    <div class="row justify-content-center mt-5">
      <div class="col-md-8 needSomeThing">
        <div class="row border">
          <div class="col-md-8 needLeft">
            <div class="contactUsTitle mt-2">{{ $t('managePlan.needSomething.title') }}</div>
            <div class="contactUsSubTitle">
              {{ $t('managePlan.needSomething.subtitle') }}
            </div>
            <button @click="setModal('ModalContactForm')" class="contactUs mt-3">{{ $t('managePlan.needSomething.button') }}</button>
          </div>
          <div class="col-md-4 colNeedImg">
            <img src="img/need.png" class="needImg" />
          </div>
        </div>
      </div>
    </div>
  </CCol>
</template>

<script>
export default {
  name: 'NeedSomething',
  computed: {},

  methods: {
    setModal() {
      this.$emit('clicked')
    },
  },
}
</script>

<style lang="scss">
.contactUs {
  background-color: #fff;
  border-radius: 5px;
  color: #403266;
  width: 200px;
  height: 40px;
  border: 1px solid #403266;
}

.contactUsTitle {
  font-size: 30px;
  color: #343a40;
  font-weight: bold;
}

.contactUsSubTitle {
  font-size: 17px;
  color: #495057;
  max-width: 500px;
}

.needSomeThing {
  background-color: #fff !important;
}

.needLeft {
  padding: 25px 35px;
}

.needImg {
  height: 220px;
  float: right;
}

.colNeedImg {
  padding-right: 0px;
}
</style>
